import Flickity from 'flickity';
import 'flickity-imagesloaded';

export default (container = document) => {

  const image_galleries = {};

  const initCarousel = ($carousel) => {
    const id = $carousel.attr('id');
    let initial_index = 0;

    if (image_galleries[id]) {
      initial_index = image_galleries[id].selectedIndex;
      image_galleries[id].destroy();
      delete image_galleries[id];
    }
  
    if ($carousel.children().length < 2) {
      // Don't init pointless carousels with 1 or no slides
      $carousel.addClass('AnimateOnLoad--loaded');
      return;
    }
  
    image_galleries[id] = new Flickity($carousel[0], {
      initial_index,
      // prevNextButtons: true,
      pageDots: false,
      wrapAround: true,
      setGallerySize: false,
      cellSelector: '[data-slide]',
      // cellAlign: 'center',
      // autoPlay: $carousel.data('autoPlay'),
      // pauseAutoPlayOnHover: $carousel.data('pauseAutoPlayOnHover'),
      adaptiveHeight: false,
      contain: true,
      imagesLoaded: true,
      draggable: true,
      on: {
        ready: () => {
          $carousel.addClass('AnimateOnLoad--loaded');
        },
        change: () => {
          $(document).trigger('notShoppableClick');
          let position = image_galleries[id].selectedIndex + 1;

          if (position < 10) {
            position = `0${position}`;
          }

          $carousel.find('[data-current-position]').html(position);
        },
      },
    });

  };

  $('[data-image-gallery]', container).each((i, gallery) => {
    initCarousel($(gallery));
  });
};